<template>
  <section class="g-container">
    <g-home></g-home>
    <g-dialog></g-dialog>
  </section>
</template>

<script>
import Home from './views/Home'
import Dialog from './components/dialog/Dialog'
export default {
  name: 'App',
  components: {
    gHome: Home,
    gDialog: Dialog,
  },
}
</script>

<style lang="scss">
body {
  font-family: 'Microsoft YaHei', Arial, Helvetica, sans-serif;
  font-size: 14px;
  min-width: 1300px;
}
.g-container {
  position: relative;
}
.v-modal {
  opacity: 0.8;
}
#dota2_topnav {
  display: none;
}
.el-dialog__header {
  display: none;
}
.el-dialog__body {
  padding: 0;
  vertical-align: middle;
  display: table-cell;
}
.el-dialog {
  box-shadow: none;
  background-color: transparent;
  width: 100%;
  height: 100%;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  display: table;
}
</style>
